import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, HStack, VStack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {calloutBoxStyle, flexStyle, hStackStyle, tagIconStyle} from './index.style'

/**
 * PromotionsSection - Displays product promotions with consistent styling
 * @param {Array} promos - Array of promotion strings or objects with calloutMsg/promotionId
 */
const PromotionsSection = ({promos}) => {
    return (
        <VStack align="start" spacing={2} width="100%">
            {promos &&
                promos.map((promo, idx) => {
                    const promoText =
                        typeof promo === 'string'
                            ? promo
                            : promo?.calloutMsg || promo?.promotionId || ''
                    return (
                        <Flex key={idx} sx={flexStyle}>
                            {promoText && (
                                <HStack sx={hStackStyle}>
                                    <Box
                                        backgroundImage={`url(${getAssetUrl(
                                            'static/img/pdp/tagIcon.svg'
                                        )})`}
                                        sx={tagIconStyle}
                                    />
                                    <Box sx={calloutBoxStyle}>
                                        <span>{promoText}</span>
                                    </Box>
                                </HStack>
                            )}
                        </Flex>
                    )
                })}
        </VStack>
    )
}

PromotionsSection.propTypes = {
    promos: PropTypes.array
}

export default PromotionsSection
